import { gql } from "@apollo/client";

export const CREATE_SURVEY = gql`
  mutation createSurvey($input: createSurveyInput) {
    createSurvey(input: $input) {
      Id
    }
  }
`;

export const GET_SURVEY = gql`
  query survey {
    survey {
      Id
      surveytitle
      questionnaires
      createdAt
      employeeName
      startDate
      endDate
      project
      emails
      department
      depatmentDetails {
        deptId
        name
      }
      role
      roleDetails {
        roleId
        name
        deptId
      }
      projectDetails {
        projectId
        projectName
      }
      orgDetails {
        logo
      }
    }
  }
`;

export const GET_SURVEYS_FOR_DROPDOWN = gql`
  query survey {
    survey {
      Id
      surveytitle
      questionnaires
    }
  }
`;

export const UPDATE_SURVEY = gql`
  mutation UpdateSurvey($input: updateSurveyInput) {
    updateSurvey(input: $input) {
      Id
    }
  }
`;

export const GET_SURVEY_BY_QUESTIONNAIRES = gql`
  query surveyByTitle($surveytitle: String) {
    surveyByTitle(surveytitle: $surveytitle) {
      Id
      surveytitle
      questionnaires
      employeeName
      department
      project
      role
      emails
    }
  }
`;
export const GET_SURVEY_QUESTIONNAIRES_BY_EMAIL_ID = gql`
  query GetsurveyquestionariesByEmailId(
    $email: String
    $surveyId: Int
    $surveysubmittedDate: String
  ) {
    getsurveyquestionariesByEmailId(
      email: $email
      surveyId: $surveyId
      surveysubmittedDate: $surveysubmittedDate
    ) {
      Id
      surveyId
      employeeId
      surveytitle
      questionaries
      surveysubmittedDate
    }
  }
`;

export const CREATE_EMPLOYEE_SURVEY = gql`
  mutation createEmployeeSurvey($input: createEmployeeSurveyInput) {
    createEmployeeSurvey(input: $input) {
      Id
    }
  }
`;

export const CREATE_PUBLIC_SURVEY = gql`
  mutation CreatePublicSurvey($input: createEmployeeSurveyInput) {
    createPublicSurvey(input: $input) {
      Id
    }
  }
`;

export const GET_EMPLOYEE_SURVEY = gql`
  query getsurveyquestionaries {
    getsurveyquestionaries {
      surveytitle
      employeeId
      questionaries
      surveyId
    }
  }
`;

export const DELETE_SURVEY = gql`
  mutation deleteSurvey($Id: Int!) {
    deleteSurvey(Id: $Id)
  }
`;
export const GET_SURVEY_BY_ID = gql`
  query GetSurveyById($Id: Int) {
    getSurveyById(Id: $Id) {
      Id
      surveytitle
      questionnaires
      createdAt
      employeeName
      startDate
      endDate
      project

      department
      depatmentDetails {
        deptId
        name
      }
      role
      roleDetails {
        roleId
        name
        deptId
      }
      projectDetails {
        projectId
        projectName
      }
      orgDetails {
        logo
      }
      orgId
    }
  }
`;
